import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Alumni_Messaging/alumni_inbox.css';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    ChatItem,
    MessageBox,
    MeetingMessage,
    SystemMessage,
    MessageList,
    ChatList,
    Input,
    Button,
    Popup,
    Navbar,
    Sidebar,
    Dropdown,
    LocationMessage,
} from 'react-chat-elements';
import 'react-chat-elements/dist/main.css';
import { BiSleepy, BiPlus } from 'react-icons/bi';
import { BASE_URL } from '../../settings';
import { displayToast } from '../../utilities';
import { Action, Fab, MB } from 'react-tiny-fab';
import io from 'socket.io-client';

import Alumni_Contacts from './Alumni_Contacts';
import moment from 'moment';

var userId;
var inboxUsername;
var inboxEmail;
var inboxFirstName;
var inboxLastName;
var inboxAvatar;

export const socket = io(`${BASE_URL}`, {
    withCredentials: true,
});

// 👇️ handler to export the alumni uuid
export const get_uuid = () => userId;

// 👇️ handler to export the alumni inbox username
export const get_inboxUsername = () => inboxUsername;

// 👇️ handler to export the alumni inbox email
export const get_inboxEmail = () => inboxEmail;

// 👇️ handler to export the alumni inbox firstName
export const get_inboxFirstName = () => inboxFirstName;

// 👇️ handler to export the alumni inbox last name
export const get_inboxLastName = () => inboxLastName;

// 👇️ handler to export the alumni inbox avatar
export const get_inboxAvatar = () => inboxAvatar;

export default function Alumni_Inbox() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const messageListReferance = useRef();
    const inputReferance = useRef();

    const [page, setPage] = useState('inbox');
    const [activeAlumni, setActiveAlumni] = useState([]);

    const [allAlumniData, setAllAlumniData] = useState([]);
    const [uuid, setUuid] = useState();
    const [username, setUsername] = useState();
    const [email, setEmail] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [githubLink, setGithubLink] = useState();
    const [linkedInLink, setLinkedInLink] = useState();
    const [facebookLink, setFacebookLink] = useState();
    const [twitterLink, setTwitterLink] = useState();
    const [about, setAbout] = useState();
    const [avatar, setAvatar] = useState();
    const [classYear, setClassYear] = useState();
    const [positionName, setPositionName] = useState();
    const [mobile, setMobile] = useState();
    const [alumniFound, setAlumniFound] = useState(false);
    const [inboxChatItems, setInboxChatItems] = useState([]);

    // 👇️ component did update
    useEffect(() => {
        document.querySelector('._3drDv')?.classList?.add('isMyprofile');
    });

    useEffect(() => {
        if (socket) {
            socket.on('new-message', (data) => {
                displayToast('new message!');
                console.log('new message:', data);
            });
        }

        if (socket) {
            socket.on('user_connected', (data) => {
                let filtered_active_alumni = data?.filter((item) => {
                    return item?.uuid != uuid;
                });
                setActiveAlumni(filtered_active_alumni);
            });
        }
    }, [socket, activeAlumni, uuid]);

    // 👇️ component will unmount
    useEffect(() => {
        return () => {
            document.querySelector('._3drDv.isMyprofile')?.classList?.remove('isMyprofile');
        };
    }, []);

    // 👇️ component did mount
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        let path = window.location.pathname?.split('/');
        let id = path[path?.length - 1];

        if (state?.alumni) {
            setAlumniFound(true);

            // 👇️ extract data from passed in alumni data
            setAllAlumniData(state?.alumni);
            setUuid(state?.alumni?.uuid);

            userId = state?.alumni?.uuid;
            inboxUsername = state?.alumni?.username;
            inboxEmail = state?.alumni?.email;
            inboxFirstName = state?.alumni?.firstName;
            inboxLastName = state?.alumni?.lastName;
            inboxAvatar = state?.alumni?.avatar;

            setUsername(state?.alumni?.username);
            setEmail(state?.alumni?.email);
            setFirstName(state?.alumni?.firstName);
            setLastName(state?.alumni?.lastName);
            setGithubLink(state?.alumni?.githubLink);
            setLinkedInLink(state?.alumni?.linkedInLink);
            setFacebookLink(state?.alumni?.facebookLink);
            setTwitterLink(state?.alumni?.twitterLink);
            setAbout(state?.alumni?.about);
            setAvatar(state?.alumni?.avatar);
            setClassYear(state?.alumni?.classYear);
            setPositionName(state?.alumni?.positionName);
            setMobile(state?.alumni?.mobile);

            if (socket) {
                socket.emit('user-join', state?.alumni);
            }
        } else {
            // 👇️ fetch alumni by id
            fetch(`${BASE_URL}/alumni/read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            })
                .then(async (response) => {
                    let data = await response.json();
                    setAlumniFound(true);

                    let fetched_alumni = data?.alumni;
                    setAllAlumniData(fetched_alumni);
                    setUuid(fetched_alumni?.uuid);

                    userId = fetched_alumni?.uuid;
                    inboxUsername = fetched_alumni?.username;
                    inboxEmail = fetched_alumni?.email;
                    inboxFirstName = fetched_alumni?.firstName;
                    inboxLastName = fetched_alumni?.lastName;
                    inboxAvatar = fetched_alumni?.avatar;

                    setUsername(fetched_alumni?.username);
                    setEmail(fetched_alumni?.email);
                    setFirstName(fetched_alumni?.firstName);
                    setLastName(fetched_alumni?.lastName);
                    setGithubLink(fetched_alumni?.githubLink);
                    setLinkedInLink(fetched_alumni?.linkedInLink);
                    setFacebookLink(fetched_alumni?.facebookLink);
                    setTwitterLink(fetched_alumni?.twitterLink);
                    setAbout(fetched_alumni?.about);
                    setAvatar(fetched_alumni?.avatar);
                    setClassYear(fetched_alumni?.classYear);
                    setPositionName(fetched_alumni?.positionName);
                    setMobile(fetched_alumni?.mobile);

                    if (socket) {
                        socket.emit('user-join', data?.alumni);
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true);
                        setAlumniFound(false);
                    } else {
                        displaySnackbar('Could not fetch alumni.', true);
                        setAlumniFound(false);
                    }
                });
        }
    }, []);

    return (
        <div className='alumni-chat-container'>
            {/* <Fab
                text='New Chat'
                icon={<BiPlus size={30} />}
                onClick={() => setPage('contacts')}
                mainButtonStyles={{
                    backgroundColor: 'darkblue',
                }}
                style={{ margin: 0, right: 20, bottom: 20 }}
            /> */}

            <Navbar
                left={
                    <button className='go-back-btn' onClick={() => navigate(-1)}>
                        👈️ Go back
                    </button>
                }
                center={<h1 style={{ color: 'white' }}>Inbox</h1>}
                type='dark'
                className='inbox-header'
            />

            <div className='messages-container'>
                {activeAlumni?.length > 0 ? (
                    activeAlumni?.map((item, index) => (
                        <ChatItem
                            key={`chat-item-#${index}`}
                            avatar={
                                item?.avatar
                                    ? `${BASE_URL}/alumni/uploads/get-profile-pic/${item?.avatar}`
                                    : require('../../images/profile-pictures/face2.jpg')
                            }
                            alt='profile-pic'
                            title={`${item?.firstName} ${item?.lastName}`}
                            subtitle={`@${item?.username} ~ ${item?.email}`}
                            date={new Date(item?.createdAt)}
                            dateString={`joined: ${moment(new Date(item?.createdAt)).fromNow()}`}
                            unread={0}
                            className='inbox-chat-item'
                            onClick={() => navigate(`/alumni/chat/${item?.uuid}`)}
                        />
                    ))
                ) : (
                    <div className='empty-inbox-container'>
                        <BiSleepy size={100} color='#777' className='empty-inbox-icon' />
                        <span> no activity yet. </span>
                    </div>
                )}
            </div>
        </div>
    );
}
